import MediaContainer from './mediaContainer';
import SizedContainer from './sizedContainer';

/**
 * @typedef {object} DecoratorElementPartial
 * @property {MediaContainer} MediaContainer - MediaContainer decorator
 * @property {SizedContainer} SizedContainer - SizedContainer decorator
 *
 * @typedef {HTMLElement & DecoratorElementPartial} DecoratorElement
 */

export { Events } from './baseDecorator';

export { MediaContainer, SizedContainer };
export const Decorators = [
	{
		name: MediaContainer.name,
		decorator: MediaContainer,
		selector:
			'.img-container, .image-container, .vid-container, .video-container, .media-container',
	},
	{
		name: SizedContainer.name,
		decorator: SizedContainer,
		selector: '.sized-container',
	},
];
